module.exports = __webpack_public_path__ + "img/chorandoDeRir.e272417c.png";